import { NextRouter } from 'next/router';
import { create } from 'zustand';

import { updateFilters } from 'layout/Listing/hooks/useUpdateFilters';

interface PressListingStore {
  search: string;
  filters: string;
}

export const pressFilterDefaultState = {
  search: '',
  filters: 'All',
};

const usePressListingStore = create<PressListingStore>(() => pressFilterDefaultState);

const updateSearch = (search: string) => ({ search });

export const updatePressFilters = (router: NextRouter, value: string) => {
  usePressListingStore.setState(() => ({ filters: value }));
  updateFilters(router, { category: value });
};

export const setPressSearch = (search: string) => usePressListingStore.setState(() => updateSearch(search));

export const clearPressFilters = () => usePressListingStore.setState(() => pressFilterDefaultState);

export default usePressListingStore;
